@if (variant === 'b') {
  <div class="yes-no-pills"
    [class.yes-no-pills--error]="isInvalid()">
    <button type="button"
      class="yes-no-pill"
      [class.yes-no-pill--selected]="yesSelected()"
      [disabled]="disabled"
      (click)="writeValue(true)">
      Yes
    </button>
    <button type="button"
      class="yes-no-pill"
      [class.yes-no-pill--selected]="noSelected()"
      [disabled]="disabled"
      (click)="writeValue(false)">
      No
    </button>
    <div class="yes-no-pills__error" [@slideInOut]="slideInOutAnimation()">
      <img class="pb-1" src="./assets/ic_error.svg">
      <span class="color-error">{{getTranslatedErrorMessage()}}</span>
    </div>
  </div>
} @else {
  <div class="parq-option">
    <label (click)="writeValue(true)" class="hand">
      <input [id]="'yes-radio-'+ngControl.name" [attr.disabled]="true" class="hand" type="radio" [value]="true">
      <a> <img class="pb-1"
      [src]="isInvalid() ? './assets/ic_radio_error.svg' : yesSelected() ? './assets/ic_radio_ok.svg' : './assets/ic_radio_select.svg'"></a>
      <span class="color-bay-club-blue"> Yes</span>
    </label>
    <label (click)="writeValue(false)" class="hand ml-2">
      &nbsp;<input [id]="'no-radio-'+ngControl.name" [attr.disabled]="true" class="hand" type="radio" [value]="false">
      <a> <img class="pb-1"
      [src]="isInvalid() ? './assets/ic_radio_error.svg' : noSelected() ? './assets/ic_radio_ok.svg' : './assets/ic_radio_select.svg'"></a>
      <span class="color-bay-club-blue"> No</span>
    </label>
    <div class="d-inline ml-3" [@slideInOut]="slideInOutAnimation()">
      <img class="pb-1" src="./assets/ic_error.svg"> <span
    class="color-error md-2">{{getTranslatedErrorMessage()}}</span>
  </div>
</div>
}
